import { AppConfig } from './config.js';

export function createApiResources(config = AppConfig) {
  return {
    activity: {
      baseUrl: config.suiteApiBaseUrl,
      path: 'activity'
    },
    admins: {
      baseUrl: config.suiteApiBaseUrl,
      path: 'profiles'
    },
    authConfigs: {
      baseUrl: config.authAppsApiBaseUrl,
      path: 'auth-configs'
    },
    billing: {
      baseUrl: config.suiteApiBaseUrl,
      path: 'billing'
    },
    brands: {
      baseUrl: config.suiteApiBaseUrl,
      path: 'business-profiles'
    },
    support: {
      baseUrl: config.suiteApiBaseUrl,
      path: 'support-tickets'
    },
    helpArticles: {
      baseUrl: config.suiteApiBaseUrl,
      path: 'help-articles'
    },
    forms: {
      baseUrl: config.formsApiBaseUrl,
      path: 'forms'
    },
    surveys: {
      baseUrl: config.surveysApiBaseUrl,
      path: 'surveys'
    }
  };
}

export const API_RESOURCES = createApiResources();
